import React from 'react';

/*
 * Android's menu icons (estimatebuilder/menu/MenuIcons.kt), path for path:
 * 24×24, round caps and joins, tinted by currentColor.
 */

type Part = {d: string; stroke?: number; fill?: boolean};

const icon = (parts: Part[]) => (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    {parts.map((p, i) => (
      <path key={i} d={p.d} strokeWidth={p.stroke ?? 0} stroke={p.stroke ? 'currentColor' : 'none'} fill={p.fill ? 'currentColor' : 'none'}/>
    ))}
  </svg>
);

export const HomeIcon = icon([
  {d: 'M3.2 10.4L12 3.2l8.8 7.2v9.4a1.4 1.4 0 0 1-1.4 1.4H4.6a1.4 1.4 0 0 1-1.4-1.4z', stroke: 2},
  {d: 'M9.4 21.2v-6.6h5.2v6.6', stroke: 1.8},
]);

export const ClientsIcon = icon([
  {d: 'M5.7 6.8a3.6 3.6 0 1 0 7.2 0a3.6 3.6 0 1 0-7.2 0', fill: true},
  {d: 'M9.3 12.4c-3.9 0-6.9 1.9-6.9 4.3v1.4h9.7a5.4 5.4 0 0 1 1.9-6c-1.4-.5-3-.7-4.7-.7z', fill: true},
  {d: 'M14 15.4a2.7 2.7 0 1 0 5.4 0a2.7 2.7 0 1 0-5.4 0', stroke: 1.9},
  {d: 'M18.7 17.4L21.6 20.4', stroke: 2.1},
]);

export const CalendarIcon = icon([
  {d: 'M5.4 4.5h13.2a2.4 2.4 0 0 1 2.4 2.4v11.7a2.4 2.4 0 0 1-2.4 2.4H5.4a2.4 2.4 0 0 1-2.4-2.4V6.9a2.4 2.4 0 0 1 2.4-2.4z', stroke: 2},
  {d: 'M3 9.6h18', stroke: 2},
  {d: 'M7.6 2.4v3.2M16.4 2.4v3.2', stroke: 2},
  {d: 'M6 12.4h4.6v4.2H6z', fill: true},
]);

export const EstimatesIcon = icon([
  {d: 'M13.6 2.6H6.6a2 2 0 0 0-2 2v14.8a2 2 0 0 0 2 2h10.8a2 2 0 0 0 2-2V8.6z', stroke: 2},
  {d: 'M13.6 2.6v6h6', stroke: 2},
  {d: 'M12 10.6v7.6', stroke: 1.6},
  {d: 'M13.9 12.6c-.35-.7-1.05-1.05-2-1.05-1.15 0-1.95.55-1.95 1.45s.75 1.2 1.95 1.45c1.3.27 2.15.7 2.15 1.65s-.85 1.55-2.15 1.55c-1.05 0-1.75-.4-2.1-1.05', stroke: 1.6},
]);

export const JobsIcon = icon([
  {d: 'M6.2 4.2h11.6a2.2 2.2 0 0 1 2.2 2.2v12.4a2.2 2.2 0 0 1-2.2 2.2H6.2a2.2 2.2 0 0 1-2.2-2.2V6.4a2.2 2.2 0 0 1 2.2-2.2z', stroke: 2},
  {d: 'M9 2.6h6v3.4H9z', stroke: 1.6, fill: true},
  {d: 'M8.2 10.8h7.6M8.2 14.2h7.6M8.2 17.4h4.6', stroke: 1.8},
]);

export const InvoicesIcon = icon([
  {d: 'M4 2.6l2.7 1.7 2.65-1.7L12 4.3l2.65-1.7 2.65 1.7L20 2.6v18.8l-2.7-1.7-2.65 1.7L12 19.7l-2.65 1.7-2.65-1.7L4 21.4z', stroke: 2},
  {d: 'M7.6 8.4h8.8M7.6 12h8.8M7.6 15.6h5.8', stroke: 1.8},
]);

export const EquipmentIcon = icon([
  {d: 'M2.4 5.4h10.8a0.8 0.8 0 0 1 0.8 0.8v8.6a0.8 0.8 0 0 1-0.8 0.8H2.4a0.8 0.8 0 0 1-0.8-0.8V6.2a0.8 0.8 0 0 1 0.8-0.8z', stroke: 2},
  {d: 'M14 8.4h3.7L21 11.9v3.7h-7z', stroke: 2},
  {d: 'M4 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0', stroke: 2},
  {d: 'M15.4 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0', stroke: 2},
  {d: 'M8 18h7.4', stroke: 1.8},
]);

export const TeamIcon = icon([
  {d: 'M5.3 8a3.2 3.2 0 1 0 6.4 0a3.2 3.2 0 1 0-6.4 0', stroke: 1.8},
  {d: 'M13.9 9a2.6 2.6 0 1 0 5.2 0a2.6 2.6 0 1 0-5.2 0', stroke: 1.8},
  {d: 'M2.5 19v-1.2A4.3 4.3 0 0 1 6.8 13.5h3.4a4.3 4.3 0 0 1 4.3 4.3V19', stroke: 1.8},
  {d: 'M16 14h1a4 4 0 0 1 4 4v1', stroke: 1.8},
]);

export const PricingIcon = icon([
  {d: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', stroke: 1.8},
  {d: 'M12 7v10', stroke: 1.8},
  {d: 'M14.5 9.4c-.4-.8-1.3-1.2-2.5-1.2-1.4 0-2.4.7-2.4 1.8s.9 1.5 2.4 1.8c1.6.3 2.6.8 2.6 2s-1.1 1.9-2.6 1.9c-1.3 0-2.2-.5-2.6-1.3', stroke: 1.8},
]);

export const SettingsIcon = icon([
  {d: 'M8.8 12a3.2 3.2 0 1 0 6.4 0a3.2 3.2 0 1 0-6.4 0', stroke: 2},
  {d: 'M19.4 13.5a7.6 7.6 0 0 0 0-3l1.9-1.5-1.9-3.3-2.3.9a7.6 7.6 0 0 0-2.6-1.5L14.1 2h-4.2l-.4 2.4a7.6 7.6 0 0 0-2.6 1.5l-2.3-.9-1.9 3.3 1.9 1.5a7.6 7.6 0 0 0 0 3l-1.9 1.5 1.9 3.3 2.3-.9a7.6 7.6 0 0 0 2.6 1.5l.4 2.4h4.2l.4-2.4a7.6 7.6 0 0 0 2.6-1.5l2.3.9 1.9-3.3z', stroke: 1.8},
]);

/** The web-only library entry (admins and curators): an open book. */
export const LibraryIcon = icon([
  {d: 'M3 5.2c2.6-1 5.6-1 9 .9v14c-3.4-1.9-6.4-1.9-9-.9z', stroke: 1.8},
  {d: 'M21 5.2c-2.6-1-5.6-1-9 .9v14c3.4-1.9 6.4-1.9 9-.9z', stroke: 1.8},
]);

